import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query Tags($page: Int, $perPage: Int, $search: String) {
    Tags(page: $page, perPage: $perPage, search: $search) {
      items {
        id
        name
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  name: string;
  id: number;
}

export interface GetAllGql {
  Tags: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
